'use client';

import classnames from 'classnames';

import Image from 'molecules/Image';
import Layout2Up from 'molecules/Layout2Up';
import RichText from 'molecules/RichText';

import styles from 'components/Switchbacks/TextWithForegroundImage/text-foreground-image.module.scss';

import type { TextWithForeGroundImageSwitchbackProps } from 'components/Switchbacks/TextWithForegroundImage/config';
import type { FC } from 'react';

const TextForegroundImage: FC<TextWithForeGroundImageSwitchbackProps> = ({
  heading,
  body,
  foregroundImage,
  backgroundColor,
  subContent,
}) => {
  const wrapperClass = classnames(styles.wrapper, {
    [styles.bkgBlue]: backgroundColor === 'blue',
    [styles.bkgGray]: backgroundColor === 'gray',
    [styles.bkgTeal]: backgroundColor === 'teal',
    [styles.bkgWhite]: backgroundColor === 'white',
    [styles.bkLightGray]: backgroundColor === 'lightgray',
    [styles.bkAsh]: backgroundColor === 'ash',
    [styles.bkDarkAsh]: backgroundColor === 'darkash',
    [styles.bkCarbon]: backgroundColor === 'carbon',
    [styles.bkWGray80]: backgroundColor === 'wgray80',
    [styles.bkGreige]: backgroundColor === 'greige',
  });

  return (
    <section className={classnames(wrapperClass)}>
      <Layout2Up
        classes={{
          wrapper: classnames(styles.compareTwoUp),
          left: classnames(styles.left),
          right: classnames(styles.right),
        }}
        left={
          <>
            {heading && <h2 className="heading3">{heading}</h2>}
            {body && <RichText className={styles.content} content={body} />}
            <div className={styles.compareQuestion}>
              {subContent?.title && (
                <p>
                  <strong>{subContent?.title}</strong>
                </p>
              )}
              {subContent?.body && <RichText content={subContent?.body} />}
            </div>
          </>
        }
        right={
          foregroundImage?.url && (
            <>
              <div className={styles.compareImage}>
                <Image
                  alt={foregroundImage?.url}
                  url={foregroundImage?.url}
                  width={foregroundImage?.width}
                  height={foregroundImage?.height}
                />
              </div>
            </>
          )
        }
      />
    </section>
  );
};

export default TextForegroundImage;
